import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import VideoCard from "./videocard";

function VideoSection() {
  const { t } = useTranslation();
  const Cdata = [
    {
      youtubeUrl: "https://www.youtube.com/watch?v=dyXREKEtXfA",
      videoDescription: "Oncquest Laboratories Ltd., is expanding its allergy profiles and panels on fully automated walkaway Phadia 250. We are offering ImmunoCAP technology which is gold standard. Some of the panels we are offering are ABPA Panel, Rhinitis, Weed Panel, Tree Panel Common Food Panel and many more.",
    },
    {
      youtubeUrl: "https://youtu.be/stZFwC01CNA",
      videoDescription: "Dr. Shivali Ahlawat, Director - Technical Operations, Oncquest Laboratories Ltd., Gurugram talks about the various misconceptions about breast cancer that needs to be understood and taken care of.",
    },
    {
      youtubeUrl: "https://youtu.be/VtdS22V4SeI",
      videoDescription: "Dr. Gale Kathleen Edward, Head Technical Operations - South and West Zone, and Lab Head - Bengaluru Lab, says “All Women face the risk of Breast Cancer but with early detection and diagnosis the chance of beating breast cancer is greater than 90 percent”.",
    },
    {
      youtubeUrl: "https://youtu.be/95FxZHRNpT8",
      videoDescription: "Dr. Bhavna Bansal, Head – Surgical Pathology, Oncquest Laboratories Ltd., Gurugram talks about the importance of multispecialty like histopathology, genetic testing, and radiological findings in diagnosing breast cancer.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=TOtXvbzy5V4",
      videoDescription: "Regular blood tests provide valuable insights into your overall health and help detect any potential underlying conditions or abnormalities and it's crucial that you choose a reliable lab.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=IzngDIrxOww&t=38s",
      videoDescription: "Dr Nimarta talks about her experience of getting a full body Health Check-up done at Oncquest Laboratories, Shruti Clinical Laboratory at Juhu, Mumbai.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=FvSRyXSVn54",
      videoDescription: "Dr. Sirisha Rani – Sr. Consultant, Paediatric Hemato Oncologist - Rainbow Children's Hospitals, Hyderabad for sharing the awareness insights on childhood and blood cancer disorders which are curable with early diagnosis, appropriate doctor consultation, and therapy.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=VB_v0-YONQI",
      videoDescription: "Dr. Prachi Jain, Senior Consultant and Incharge, Pediatric Oncology and Hematology, Max Super Specialty Hospital-Patparganj and Delhi NCR talks about the various symptoms that indicate blood cancer and key symptoms not to miss out.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=-NXJsiT8_58",
      videoDescription: "Dr. Anoop P, Haemato - Oncologist, Aster Hospitals, Bengaluru, briefs about the major types of blood cancer and key points to differentiate them for better diagnosis. These types can affect people of all ages and are important to be diagnosed as early as possible.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=qHJttjDve04",
      videoDescription: "Why go for a Preventive Health check-up in Oncquest Laboratories? It' s a highly advanced lab with tonnes of the latest facilities - We provide research-based health insights along with the digitally enabled solutions - We are quick with their hassle-free testing experience - We have a test menu of over 4000+ tests whose sample collection facility is even provided at your doorstep - Most importantly, we follow all safety protocols and the lab is highly hygienic.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=8CGXYqe7Uek",
      videoDescription: "At Oncquest Laboratories Ltd., we believe in raising our voices together to spread the word and create awareness about the importance of breast cancer screening and support. Early detection not only provides the best chance for treatment but also helps in increasing survival rates.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=txqA3IDPaWE",
      videoDescription: "Want to know more - Listen to our expert Dr. Shivali Ahlawat speaking in this video on the Scenario of Breast cancer in India and the role of early diagnosis and screening for better survival outcomes. When it comes to your health #ignoranceisnotbliss.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=Lc-7T8WTpus",
      videoDescription: "Listen to our expert Dr. Vinay Bhatia on how precision medicine plays a significant role in making a more accurate diagnosis. When it comes to your health 'Ignorance is not bliss'.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=JeoZaLVm8Es",
      videoDescription: "At Oncquest Laboratories Ltd., we believe in raising our voices together to spread the word and create awareness about the importance of breast cancer screening and support. Early detection not only provides the best chance for treatment but also helps in increasing survival rates.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=uHY1kJbuQjE",
      videoDescription: "Liquid biopsy in lung cancer is evolving as an important added tool for screening, early detection, monitoring, and even prognostication of lung cancer. LB is mainly utilized as an auxiliary tool in lung cancer diagnosis when a LDCT detects an abnormality. Early detection could be pursued using different approaches, such as diagnostic imaging techniques in high-risk individuals, including low-dose computed tomography (LDCT).",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=q0OoS8Ihbbs",
      videoDescription: "Your Health should never be an obstacle. Book your preventive health checkup to detect early symptoms for diagnosis.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=8MvwHOLlmME&t=1s",
      videoDescription: "We thank all our doctors, technical team, healthcare workers and teammates for partnering with our new initiative on World Cancer Day. Thank you for your participation & feedback on this awareness campaign that we will continue to carry out in the years ahead as when it comes to your health –“Ignorance is not Bliss”",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=b8ngkLo4aBw",
      videoDescription: "Early detection increases the possibility of a healthy outcome. Biopsy, Cytology, Radiology along with Blood test helps in diagnosing cancer at early stage. Consult your doctor today to know more.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=39lapelTKSM",
      videoDescription: "Ignoring bad habits & negativity can be bliss for you but when it comes to your health IGNORANCE IS NOT BLISS. Early detection & diagnosis makes treatment more effective. This World Cancer Day let’s come together and join this initiative towards raising awareness and defeating cancer.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=kHVRefRLr4g&t=6s",
      videoDescription: "Oncquest is out there in your city, educating on the importance of preventive health checks, doing free health screenings to get you started, and doing its bit to keep India Healthy.",
    },
    {
      youtubeUrl: "https://www.youtube.com/watch?v=zOH5sZ5evmI&t=3s",
      videoDescription: "Dr. Bushra shares her wonderful experience of her #preventivehealthcheck experience at #Oncquestlaboratories.",
    },
    {
      youtubeUrl: "https://youtube.com/shorts/c17nr36u7gI?feature=share",
      videoDescription: "Listen to RJ Khurafati Nitin delivering a message from Oncquest on the need to keep our lungs healthy.",
    },
    {
      youtubeUrl: "https://youtu.be/nKW1-AmDU_Y",
      videoDescription: "Oncquest Laboratories Ltd. wins the Award of Excellence in healthcare for 2021 at Ayushman India organised by Dainik Jagran.",
    },
    {
      youtubeUrl: "https://youtu.be/29BISMOf44c",
      videoDescription: 'A session on "3 steps to defeating cancer" by Dr. Shivali Ahlawat.',
    },
  ];

  return (
    <>
    <SeoAdd slug={ROUTE.VIDEOSECTION} />
      <BreadCrumb page={t("videos")} data={{ slug: "", path: "#" }} />
      <section className="team-section video-section-n">
        <div className="container">
          <div className="tab-content mb-4">
            <div className="mt-25 text-center">
              <h2>{t("videos")}</h2>
              <div className="mt-10-v">
                <p className="text-center dull_heading pb-3">
                  {t("video_content")}
                </p>
              </div>
            </div>
            <>
              <div className="equal_clm h-services testimonial_list equal_clm_video">
                {Cdata.map((val) => {
                  return (
                    <>
                      <VideoCard 
                      youtubeUrl={val.youtubeUrl} 
                      videoDescription={val.videoDescription} 
                      />
                    </>
                  );
                })}
              </div>
            </>
          </div>
        </div>
      </section>
    </>
  );
}

export default VideoSection;
